import { Package } from 'pages/newSubscription/models';
import { ISchoolDetails } from 'pages/subscribe/models';

export interface IAccountUser {
  name: string;
  id: string;
}

export interface ISchoolInfo {
  schoolName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  townCity: string;
  county: string;
  country: string;
  postcodeZipcode: string;
}

export type SchoolUser = {
  userID: number;
  userName: string;
  userEmail: string;
};

export type SchoolUsers = SchoolUser[];

export enum UpgradeFreeSubscriptionStep {
  CHOOSE_PACKAGE,
  SCHOOL_DETAILS,
  PAYMENT_TYPE,
  PAYMENT_DETAILS,
  CONFIRMATION,
}

export class UpgradeSubscriptionParser {
  public static buildSchoolDetailsPayload = (values: ISchoolDetails) => ({
    ...values,
    addressLine2: values.addressLine2 ? values.addressLine2 : null,
    addressLine3: values.addressLine3 ? values.addressLine3 : null,
    county: values.county ? values.county : null,
  });

  public static buildSchoolUserAccess = (
    selectedUsers: string[],
    selectedPackages: Package[]
  ) => ({
    packageIDs: selectedPackages.map((p: Package) => p.packageID),
    idsToGrantAccess: selectedUsers.map((i: string) => parseInt(i)),
  });

  public static getPageHeaderInfo = (step: number) => {
    switch (step) {
      case UpgradeFreeSubscriptionStep.CHOOSE_PACKAGE:
        return {
          title: 'Choose your package',
          nextStep: 'School details',
        };
      case UpgradeFreeSubscriptionStep.SCHOOL_DETAILS:
        return {
          title: 'Enter school details',
          nextStep: 'Payment type',
        };
      case UpgradeFreeSubscriptionStep.PAYMENT_TYPE:
        return {
          title: 'Payment type',
          nextStep: 'Payment details / Confirmation',
        };
      case UpgradeFreeSubscriptionStep.PAYMENT_DETAILS:
        return { title: 'Payment details', nextStep: '' };
      case UpgradeFreeSubscriptionStep.CONFIRMATION:
        return { title: 'Confirmation', nextStep: '' };
      default:
        return { title: '', nextStep: '' };
    }
  };
}
